import React from 'react'
import {
  Left,
  Text,
  Footer,
  TextTitle,
  TextSimple,
  Right,
  Status,
  Header,
  ItemInvoiceLocked,
  WrapperLocked,
  Link
} from '../styles'
import { IconLocked } from '../../../../../assets/svg/icon-locked'

export const LockedDelayedInvoice = ({ item, formattedPrice, dueDate, invoiceIuguUrl }) => (
  <ItemInvoiceLocked pastDelayLimit>
    <Header disabled>
      <Left>
        <TextTitle>{formattedPrice}</TextTitle>
        <TextSimple>
          Vencimento: <br />
          {dueDate}
        </TextSimple>
        <Link>
          <a href={invoiceIuguUrl} target="_blank" rel="noopener noreferrer">
            Ver boleto
          </a>
        </Link>
      </Left>
      <WrapperLocked>
        <IconLocked />
      </WrapperLocked>
      <Right>
        <Text>Fatura atrasada</Text>
        <Status color="#bcbcbc" />
      </Right>
    </Header>

    <Footer disabled>
      <Right>
        <TextSimple>{item.isUpfront ? 'Entrada' : `${item.number}/${item.amountOfItems}`}</TextSimple>
      </Right>
    </Footer>
  </ItemInvoiceLocked>
)
